import { pickFile } from '../helpersMobileShared';

export const chooseFileSagaTypeDictionary = { file: pickFile };
